/* Blu Studio custom interactions */
(function () {
  if (window.__bluProductCardReady) return;
  window.__bluProductCardReady = true;

  function previewSwatch(swatch) {
    var card = swatch.closest('.blu-product-card');
    if (!card) return;
    var image = card.querySelector('.blu-product-card__image--primary');
    var nextSrc = swatch.getAttribute('data-image-src');
    if (!image || !nextSrc) return;

    if (!image.dataset.defaultSrc) {
      image.dataset.defaultSrc = image.currentSrc || image.src || '';
      image.dataset.defaultSrcset = image.getAttribute('srcset') || '';
    }

    image.removeAttribute('srcset');
    image.src = nextSrc;
    card.querySelectorAll('[data-blu-color-swatch]').forEach(function (el) {
      el.classList.remove('is-previewing');
    });
    swatch.classList.add('is-previewing');
  }

  function resetCard(card) {
    if (!card) return;
    var image = card.querySelector('.blu-product-card__image--primary');
    if (image && image.dataset.defaultSrc) {
      image.src = image.dataset.defaultSrc;
      if (image.dataset.defaultSrcset) image.setAttribute('srcset', image.dataset.defaultSrcset);
    }
    card.querySelectorAll('[data-blu-color-swatch]').forEach(function (el) {
      el.classList.remove('is-previewing');
    });
  }

  document.addEventListener('mouseover', function (event) {
    var swatch = event.target.closest('[data-blu-color-swatch]');
    if (swatch) previewSwatch(swatch);
  });

  document.addEventListener('focusin', function (event) {
    var swatch = event.target.closest('[data-blu-color-swatch]');
    if (swatch) previewSwatch(swatch);
  });

  document.addEventListener('mouseout', function (event) {
    var swatches = event.target.closest('.blu-product-card__swatches');
    if (swatches && !swatches.contains(event.relatedTarget)) resetCard(swatches.closest('.blu-product-card'));
  });

  document.addEventListener('focusout', function (event) {
    var swatches = event.target.closest('.blu-product-card__swatches');
    if (swatches && !swatches.contains(event.relatedTarget)) resetCard(swatches.closest('.blu-product-card'));
  });
})();
